var ChildContextMenuView = require('childcontextmenuview');


var ConversationContextMenuView = ChildContextMenuView.extend({
    el: '#conversationContextMenu',
    events: $.extend({}, ChildContextMenuView.prototype.events, {
        'buttonClick button.delete': 'clickDelete',
        'buttonClick button.whois': 'clickWhois',
        'buttonClick button.rename': 'clickRename'
    }),
    clickDelete: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('deleteConfirm');
        this.clearContext();
    },
    clickWhois: function (e) {
        e.preventDefault();
        if (this.buffer.isActive()) {
            this.hide();
            this.buffer.getRecipient().whois();
            this.clearContext();
        }
    },
    clickRename: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('renamePrompt', this.buffer.getName());
        this.clearContext();
    },
    onShow: function () {
        this.deactivateItem(this.$('li.whois'), !this.buffer.isActive());
        
        ChildContextMenuView.prototype.onShow.call(this);
    },
});


module.exports = ConversationContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/conversationcontextmenuview.js
// module id = tlSk
// module chunks = 1